import { render, staticRenderFns } from "./waringpage.vue?vue&type=template&id=4daeaeda"
import script from "./waringpage.vue?vue&type=script&lang=js"
export * from "./waringpage.vue?vue&type=script&lang=js"
import style0 from "./waringpage.vue?vue&type=style&index=0&id=4daeaeda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports